import { defineStore, acceptHMRUpdate } from 'pinia'
import api from "../services/api.js";

export const useOrderStore = defineStore('orders',  {

    state: () => ({
        _statuses: [],
        _pending_statuses: [],
        _completed_statuses: [],
        _orders: null,
        _orderStats: null,
        _order: null,
        _orderHistory: null,
        _stats: null,
    }),

    getters: {
        statuses: (state) => state._statuses,
        pending_statuses: (state) => state._pending_statuses,
        completed_statuses: (state) => state._completed_statuses,
        orders: (state) => state._orders,
        orderStats: (state) => state._orderStats,
        order: (state) => state._order,
        orderHistory: (state) => state._orderHistory,
        stats: (state) => state._stats,
    },

    actions: {
        async getOrders(params) {
            const response = await api.get('orders', params)
            this._orders = response.data
        },
        resetOrders() {
            this._orders = null
        },
        async getOrderOverviewStats(status) {
            const response = await api.get('orders/overview-stats', {status})
            this._orderStats = response.data
        },

        async getStats(date) {
            this._stats = null
            const response = await api.get(`orders/stats`, {date})
            this._stats = response.data
        },

        async getOrder(orderId) {
            const response = await api.get(`orders/${orderId}`)
            this._order = response.data.order
            this._orderHistory = response.data.history
        },
        async searchOrders(query, status) {
            const response = await api.post(`orders/search`, {query: query, status: status})
            this._orders = response.data
        },
        async exportOrders(params) {
            await api.post('orders/export', params)
        },
        async getStatuses() {
            const response = await api.get('orders/status')
            this._statuses = response.data.all
            this._pending_statuses = response.data.pending
            this._completed_statuses = response.data.complete
        },
        async dormantOrder(reason) {
            await api.post(`orders/${this._order.uuid}/dormant`, { reason })
        },
        async unprocessOrder(reason) {
            await api.post(`orders/${this._order.uuid}/unprocess`, { reason })
        }
    },
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useOrderStore, import.meta.hot))
}
